import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	placeholder: {
		id: 'servicedesk-insight-attribute-views.project.placeholder',
		defaultMessage: 'No projects selected',
		description: 'Message displayed when there are no projects selected for an attribute',
	},
});
